'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak
var TRANSITION_STATUS_UPDATED = exports.TRANSITION_STATUS_UPDATED = 'TRANSITION_STATUS_UPDATED';
var STATE_REQUESTED = exports.STATE_REQUESTED = 'STATE_REQUESTED';
var STATE_CHANGED = exports.STATE_CHANGED = 'STATE_CHANGED';
var TRANSITION_STARTED = exports.TRANSITION_STARTED = 'TRANSITION_STARTED';
var TRANSITION_FINISHED = exports.TRANSITION_FINISHED = 'TRANSITION_FINISHED';
//# sourceMappingURL=NavigatorEvent.js.map